import React from 'react';
import './styles.scss';
import { Box, Typography, Button, TextField, Grid } from '@mui/material';
import moment from 'moment';
import logo from '../../../assets/images/w-logo.png';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';

const Footer = () => {
    const cookie = new Cookies();

    return (
        <Box className="footerWrapper">
            <Grid container spacing={2} padding='24px'>
                <Grid item xs={12} sm={4} display='flex' flexDirection='column' alignItems='center'>
                    <img src={logo} width={45} height={50} alt='footer-logo' />
                    <Typography variant='h6' color='white' mt={1} fontWeight='bold'>MsRecover</Typography>
                    <Typography color='white' mt={1}>
                        Protecting your investments, securing your future.
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant='h6' color='white' fontWeight='bold' marginBottom={2}>Quick Links</Typography>
                    <Box display='flex' flexDirection='column' alignItems='flex-start'>
                        <Link to="/" className='footerLink'>Home</Link>
                        <Link to="/about" className='footerLink'>About Us</Link>
                        <Link to="/scenarios" className='footerLink'>Scenarios</Link>
                        <Link to="/system" className='footerLink'>System</Link>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant='h6' color='white' fontWeight='bold' marginBottom={2}>Stay Connected</Typography>
                    <Link to={cookie?.get('token') ? '/contact-us' : '/signin'}>
                        <Button variant="contained" sx={{ mt: 2 }} fullWidth>Connect With Us</Button>
                    </Link>
                </Grid>
            </Grid>
            <Box className='footerCopyRight'>
                <Typography variant='span16'>
                    ©{moment().format('YYYY')} MsRecover - All Rights Reserved
                </Typography>
            </Box>
        </Box>
    );
}

export default Footer;
